import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import { ScrollView as RNScrollView } from 'react-native';

import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  margin-top: -${RFValue(20)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const InfoList = styled.View``;
export const HelpVideoContainer = styled.TouchableOpacity`
  width: 100%;
  justify-content: flex-end;
  height: ${RFPercentage(35)}px;
`;

//@ts-ignore
export const HelpVideoThumb = styled(FastImage)`
  width: 100%;
  height: 100%;
`;

export const VideoInfos = styled.View`
  position: absolute;
  bottom: ${RFValue(32)}px;
  padding: 0 24px;
`;
export const HelpVideoTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
`;

export const HelpVideoSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};
`;

export const ScrollContainer = styled(RNScrollView)`
  flex: 1;
`;

export const InfoItem = styled.View`
  margin-bottom: ${RFValue(12)}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;
export const InfoItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-top: -5px;
`;
export const InfoDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const InfoItemContent = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const Footer = styled.View`
  margin-bottom: ${getBottomSpace() ? getBottomSpace() : RFValue(20)}px;
  padding: 8px 24px 0 24px;
`;

export const StatementButton = styled.TouchableOpacity`
  height: ${RFValue(32)}px;
  padding: 0 16px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const StatementButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  text-decoration-line: underline;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(12)}px;
`;

export const SupportContactList = styled.View`
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(8)}px;
`;
export const SupportContactItem = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(4)}px;
  align-items: center;
`;
export const SupportContactIcon = styled(Feather)`
  margin-right: ${RFValue(6)}px;
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
`;
export const SupportContactText = styled.Text`
  color: ${({theme}) => theme.colors.text};
`;
export const ReferAndWinbutton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;

  margin-top: ${RFValue(12)}px;
`;
export const ReferAndWinbuttonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;
